import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';

import { IonicModule } from '@ionic/angular';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { ReportTableComponent } from './report-table.component';


@NgModule({
  declarations: [
    ReportTableComponent
  ],
  imports: [
      IonicModule,
      CommonModule,
      NgxDatatableModule,
      MatTableModule,
      MatPaginatorModule,
      MatSortModule
  ],
  exports: [
    ReportTableComponent
  ]
})
export class ReportTableModule {}
